import icHeartEmpty from '../../assets/img/ic-heart-empty.svg';
import icHeartFull from '../../assets/img/ic-heart-full.svg';

const formatLanguages = (languages) => {
    if (!Array.isArray(languages)) return '—';

    const languageNames = languages
        .map((language) => String(language || '').trim())
        .filter(Boolean);

    return languageNames.length > 0 ? languageNames.join(', ') : '—';
};

const MobileDiscoveryCountryCard = ({
    country,
    isFavorite = false,
    onFavoriteToggle,
    onOpenCountry,
}) => {
    const countryName = country.countryName || country.country?.name || '—';
    const countryId = country.country?.id || country.country || '—';

    const handleOpenCountry = () => {
        if (onOpenCountry) onOpenCountry(country);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpenCountry();
        }
    };

    const handleFavoriteClick = (event) => {
        event.stopPropagation();
        if (onFavoriteToggle) onFavoriteToggle(country._id);
    };

    return (
        <article
            className="mobile-company-card mobile-country-card"
            role="button"
            tabIndex={0}
            onClick={handleOpenCountry}
            onKeyDown={handleKeyDown}
        >
            <div className="mobile-company-card__body">
                <div className="mobile-company-card__top mobile-country-card__top">
                    <div className="mobile-company-card__identity">
                        <div className="mobile-company-card__meta">
                            <p className="mobile-country-card__continent">
                                {country.continent || '—'}
                            </p>
                            <h3 className="mobile-company-card__title mb-0">
                                {countryName}
                            </h3>
                            <p
                                className="mobile-country-card__languages"
                                title={formatLanguages(country.languagesSpoken)}
                            >
                                {formatLanguages(country.languagesSpoken)}
                            </p>
                        </div>
                    </div>

                    <div className="mobile-company-card__actions mobile-company-card__actions--favorite-only">
                        <button
                            className={`mobile-company-card__favorite${isFavorite ? ' is-active' : ''}`}
                            type="button"
                            aria-label={isFavorite ? `Remove ${countryName} from favorites` : `Add ${countryName} to favorites`}
                            aria-pressed={isFavorite}
                            onClick={handleFavoriteClick}
                            onKeyDown={(event) => event.stopPropagation()}
                        >
                            <img
                                src={isFavorite ? icHeartFull : icHeartEmpty}
                                alt=""
                                aria-hidden="true"
                            />
                        </button>
                    </div>
                </div>
            </div>

            <div
                className="mobile-company-card__stats-strip mobile-company-card__stats-strip--two"
                aria-label="Country details"
            >
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">ID</span>
                    <span className="mobile-company-card__stat-value">{countryId}</span>
                </div>
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">Cities</span>
                    <span className="mobile-company-card__stat-value">{country.cityCount || 0}</span>
                </div>
            </div>
        </article>
    );
};

export default MobileDiscoveryCountryCard;
